import React, { Component } from "react";
import DatePicker from "react-datetime";

import { COLORS } from "../../../../../utils/theme";
import DateTimeService from "../../../../../utils/dateTimeService";

export default class TheDatePicker extends Component {
  render() {
    return (
      <DatePicker
        key={this.props.value}
        dateFormat="YYYY-MM-DD"
        timeFormat={false}
        value={this.props.value}
        onChange={(dateTime) => this.props.onChange(this.props.name, dateTime)}
        inputProps={{
          placeholder: "YYYY-MM-DD",
          style: {
            height: "38px",
          },
          disabled: this.props.isDisabled,
        }}
        renderView={(_, renderDefault) =>
          this.renderView(
            renderDefault,
            (e) => {
              e.preventDefault();
              this.props.onChange(this.props.name, null);
            },
            (e) => {
              e.preventDefault();
              this.props.onChange(
                this.props.name,
                new DateTimeService().normalized
              );
            }
          )
        }
      />
    );
  }

  renderView(renderDefault, onClear, onSelectToday) {
    return (
      <div>
        {renderDefault()}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            margin: "10px",
            color: COLORS.alliance_blue,
          }}
        >
          <button onClick={onClear}>Clear</button>
          <button onClick={onSelectToday}>Today</button>
        </div>
      </div>
    );
  }
}
